export enum Permission {
  ShoppingListShoppingListModify = 'shopping_list_shoppers_retailer_settings.modify',
  ShoppingListShoppingListView = 'shopping_list_shoppers_retailer_settings.view',
}
